import { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Auth } from '../../config/configuration/react';
import { RULES_AUTHORIZED } from '../../config';
import { store } from '../../Store/store';

const useAuth = () => {
  const [authStatus, setAuthStatus] = useState('loading');
  const [globalError, setGlobalError] = useState(null);
  const [accessToken, setAccessToken] = useState(Auth.token());
  const { isAuthenticated, getIdTokenClaims, user, logout, isLoading, loginWithRedirect, error } = useAuth0();

  const getUserInformation = useCallback(async () => {
    try {
      const { __raw: token } = await getIdTokenClaims();
      if (!token) throw new Error('user token not exist');
      if (accessToken !== token) {
        await Auth.setToken(token);
        setAccessToken(token);
        await Auth.setApp(user.office_apps);
        await Auth.getCurrentUser();
      }
      if (!Auth.hasRules(RULES_AUTHORIZED)) throw new Error('user_have_no_right_to_use_app');
      setAuthStatus('success');
    } catch (e) {
      setGlobalError(e.message);
      setAuthStatus('not-authenticated');
    }
  }, [accessToken, getIdTokenClaims, user, logout]);

  const resetState = async () => {
    await store.dispatch({ type: 'RESET_STATE' });
  };

  useEffect(() => {
    if (isAuthenticated) {
      getUserInformation();
    } else if (isLoading) {
      setAuthStatus('loading');
    } else {
      setAuthStatus('not-authenticated');
      resetState();
    }
  }, [isAuthenticated, getUserInformation, isLoading]);

  return {
    authStatus,
    logout,
    error: (error?.message !== 'Invalid state' && error?.message) || globalError,
    loginWithRedirect,
    isAuthenticated,
  };
};

export default useAuth;
